import React, { useEffect } from 'react'
import BillingCard from '../../components/subscription-component/BillingCard'
import PaymentMethod from "../../components/subscription-component/PaymentMethod"
import BillingTable from "../../components/subscription-component/BillingTable"
import { useOutletContext } from 'react-router-dom'

const PaymentBilling = () => {
   const {setNavigation} = useOutletContext();
   useEffect(()=>{
    setNavigation("compare-plan")
   },[])
  return (
 <div>
     <div style={{display:"flex",gap:"20px"}}>
      <BillingCard/>
      <PaymentMethod/>
    </div>
    <div>
      <BillingTable/>
    </div>
 </div>
  )
}

export default PaymentBilling;
